import { BsQuestionCircle } from "react-icons/bs";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const FormRow = ({
  type,
  name,
  value,
  handleChange,
  labelText,
  className,
  style,
  handleBlur,
  tooltipContent,
  disabled,
}) => {
  return (
    <div className="form-row" style={style}>
      <div style={{ display: "flex" }}>
        <label htmlFor={name} className="form-label">
          {labelText || name}
        </label>
        {tooltipContent && (
          <Tippy content={tooltipContent}>
            <div>
              <BsQuestionCircle className="info-icon" />
            </div>
          </Tippy>
        )}
      </div>
      <input
        type={type}
        value={value}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        className={`form-input ${className}`}
        disabled={disabled}
      />
    </div>
  );
};

export default FormRow;
